<template>
  <div>
    <b-row class="justify-content-center mt-2 mb-4">
      <span class="center-title">Your Order</span>
    </b-row>
    <EmptyCart v-if="cartItemsCount == 0"/>
    <div v-else>
      <b-row>
        <OrderProducts />
        <OrderSummary />
      </b-row>
    </div>
  </div>
</template>

<script>
import OrderProducts from "../components/cart-components/OrderProducts";
import OrderSummary from "../components/cart-components/OrderSummary";
import EmptyCart from "../components/EmptyCart";

//import RecommendationSection from "../components/RecommendationSection";
import { mapGetters } from "vuex";

export default {
  name: "Cart",
  components: {
    OrderProducts,
    OrderSummary,
    EmptyCart
 //   RecommendationSection,
  },
  computed: {
    ...mapGetters({
      cartItems: "getCartItems",
      cartItemsCount: "getCartItemsCount",
    }),
  },
};
</script>

